import { Box, makeStyles } from '@material-ui/core';
import React from 'react'
import Player from '../types/Player';
import { COLOR_BLACK, COLOR_TEXT } from '../styles/colors';
import DropDown, { DropDownItem } from '../atoms/DropDown';
import { TEAM_TYPE } from '../templates/UpdatedPlayerPageTemplate';
import UpdatedLastUpdated from './UpdatedLastUpdated';

interface ViewControlsProps {
  player: Player | undefined,
  selectedTeamType: string,
  setSelectedTeamType: React.Dispatch<React.SetStateAction<string>>;
}

const useStyles = makeStyles(theme => ({
  viewControlWrap: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  lastUpdated: {
    alignItems: 'center',
    color: COLOR_TEXT,
    display: 'flex',
    fontSize: theme.typography.pxToRem(14),
  },
  '@media (max-width: 1279px)': {
    lastUpdated: {
      top: '10px',
      right: 'inherit',
      justifyContent: 'center',
      width: '100%',
      padding: theme.spacing(0,2),
    },
  },
  educationDropDown: {
    boxShadow: 'none',
    flexShrink: 0,
    justifyContent: 'center',
    minWidth: 140,
  },
  educationDropDownSelectorRoot: {
    border: '2px solid efefef',
    boxShadow: 'none',
    boxSizing: 'border-box',
    paddingRight: theme.spacing(5),
    minHeight: '40px',
  },
  dropdownFieldsetClass: {
    '& fieldset': {
      boxShadow: 'none',
    },
  },
  infoIcon: {
    color: COLOR_BLACK,
    height: 30,
    width: 30,
  }
}), { name: ViewControls.name });

export default function ViewControls(props: ViewControlsProps) {
  const {
    player,
    selectedTeamType,
    setSelectedTeamType
  } = props;
  const classes = useStyles();
  const playerHasHighSchools = player && player.highSchools && player.highSchools.length > 0;
  const playerHasColleges = player && player.playerColleges && player.playerColleges.length > 0;
  const playerHasNFLTeams = player && player.playerNFLTeams && player.playerNFLTeams.length > 0;

  return (
    <Box component="section" className={classes.viewControlWrap}>
        {player?.id && player?.lastPublishedDate && 
          <UpdatedLastUpdated
            className={classes.lastUpdated}
            playerId={player.id}
            datetime={player.lastPublishedDate}
            iconClassName={classes.infoIcon}
          />
        }
      {player?.lastPublishedDate ? (
        <DropDown
          className={classes.educationDropDown}
          selectorRootClassName={classes.educationDropDownSelectorRoot}
          items={[
            (playerHasHighSchools || playerHasColleges || playerHasNFLTeams) && { content: 'High School', value: TEAM_TYPE.HIGH_SCHOOL },
            (playerHasColleges || playerHasNFLTeams) && { content: 'College', value: TEAM_TYPE.COLLEGE },
            playerHasNFLTeams && { content: 'NFL', value: TEAM_TYPE.NFL }
          ].filter(Boolean) as DropDownItem[]}
          value={selectedTeamType}
          onChange={(value:string) => setSelectedTeamType(value)}
          fieldsetClassName={classes.dropdownFieldsetClass}
        />
      ) : ''}
    </Box>
  )
}
